export default {
  C: 'Custo de mercadoria/serviço prestado',
  D: 'Despesa ocasional',
  F: 'Custo fixo',
  I: 'Investimento',
  O: 'Outros impostos e encargos',
  R: 'Receita',
  V: 'Despesa variável de venda/deduções da receita',
};
